import { Component, OnInit,Input } from '@angular/core';
import { FormGroup,FormControl,Validators} from '@angular/forms';
import { almenosUnTipoUsuarioValidator } from 'src/app/validators/validadores.validator'


@Component({
  selector: 'app-add-usuarios',
  templateUrl: './add-usuarios.component.html',
  styleUrls: ['./add-usuarios.component.scss']
})
export class AddUsuariosComponent implements OnInit {

  @Input()  opcionesSeleccionada: number;
  nuevoUsuario: FormGroup;
  tiposUsuario:string[];
  tipoUsuario:string[]=['Solicitante Proyectos','Solicitante cambios',
                      'Administrador Desarrollo', 'Administrador análisis',
                      'Análista Sr','Análista Jr','Líder de Proyecto','Mesa servicio']
 /*Checks para los tipos de usuarios */
  usSolicitanteProyecto = false;
  usSolicitanteCambios = false;
  usAdministradorDesarrollo = false;
  usAdministradorAnalisis = false;
  usAnalistaSr = false;
  usAnalistaJr = false;
  usLiderProyecto = false;
  usMesaServicio= false;

  constructor() { }

  ngOnInit() 
  {
    //Creamos el modelo del nuevo usuario
    this.nuevoUsuario= new FormGroup({
      usuario_cuenta:new FormControl('',[Validators.required, Validators.email]),
      //usuario_idtipoUsuario: new FormControl((this.opcionesSeleccionada)),
      usuario_nombre:new FormControl('',[Validators.required]),
      usuario_puesto:new FormControl('',[Validators.required]),
      usuario_dependencia:new FormControl('',[Validators.required]),
      usuario_direccionArea:new FormControl('',[Validators.required]),
      tiposUsuario: new FormGroup(
        {
          1: new FormControl(''),
          2: new FormControl(''),
          3: new FormControl(''),
          4: new FormControl(''),
          5: new FormControl(''),
          6: new FormControl(''),
          7: new FormControl(''),
          8: new FormControl(''),

        },
        almenosUnTipoUsuarioValidator()
        
        )
    });
  }

  get f() { return this.nuevoUsuario.controls; }


  onSubmit() 
  {
    if (this.nuevoUsuario.invalid) 
    {
      return;
    }
    else{

    }
    
    
  }



   //limpiar impactos
   limpiarCampoTipoUsuarios(tipoU: number) {
    switch (tipoU) {
      case 1:
        this.nuevoUsuario.get('tiposUsuario.1').reset();
        break;     
      case 2:
        this.nuevoUsuario.get('tiposUsuario.2').reset();
        break;   
      case 3:
          this.nuevoUsuario.get('tiposUsuario.3').reset();
        break; 
      case 4:
            this.nuevoUsuario.get('tiposUsuario.4').reset();
            break; 
      case 5:
            this.nuevoUsuario.get('tiposUsuario.5').reset();
            break;
      case 6:
            this.nuevoUsuario.get('tiposUsuario.6').reset();
            break;  
      case 7:
              this.nuevoUsuario.get('tiposUsuario.7').reset();
              break;
        case 8:
            this.nuevoUsuario.get('tiposUsuario.8').reset();
            break;
    }
  }
}
